import { Navigate } from "react-router-dom";
import { getLandingRoute, isAuthenticated, readSessionToken } from "app/services/app.state.service";

export function PublicOnlyRoute({ children }) {
    if (isAuthenticated() && readSessionToken()) {
      return <Navigate to={getLandingRoute()} replace />;
    }

    return children;
}
